import React from 'react';
import Props from 'prop-types';

const Icon = ({ color, className, onClick, children, style }) => {
	style = { color, ...style };
	const classes = 'material-icons' + (className ? ' ' + className : '');

	return (
		<i className={classes} style={style} onClick={onClick}>
			{children}
		</i>
	);
};

Icon.propTypes = {
	children: Props.string.isRequired,
	color: Props.string,
	className: Props.string,
	style: Props.object,
	onClick: Props.func
};

export default Icon;
